import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Images
import img1 from "../../../assets/EMP_Retails/RetailsSlider/Reduced-turnover-1.webp";

import img2 from "../../../assets/EMP_Retails/RetailsSlider/Incentivize-shift-pickup.webp";

import img3 from "../../../assets/EMP_Retails/RetailsSlider/improve-timeclock-compliance-1-1.webp";

import img4 from "../../../assets/EMP_Retails/RetailsSlider/Minimize-seasonal-needs.webp";

import img5 from "../../../assets/EMP_Retails/RetailsSlider/circle-bg-1.webp";

import img6 from "../../../assets/EMP_Retails/RetailsSlider/Financial-wellness-1.webp";

import img7 from "../../../assets/EMP_Retails/RetailsSlider/Competitive-benefit-1.webp";

// import img8 from "../../../assets/EMP_Retails/RetailsSlider/circle-bg-1.webp";

export default function RetailsSlider() {

  const cards = [
    {
      image: img1,
      title: "Reduce retail turnover",
      text: "44% of retail workers are looking to leave retail completely,1 but offering DailyPay can help mitigate this risk. In fact, 30% of employers using DailyPay have seen a reduction in employee turnover.",
    },
    {
      image: img2,
      title: "Incentivized shift pick up and attendance",
      text: "56% of DailyPay users in the retail industry say they pick up at least one extra shift per month because they know they can access earned pay ahead of payday.3",
    },
    {
      image: img3,
      title: "Improve timeclock compliance",
      text: "Employees can become more diligent with punches and reduce timecard errors.4",
    },
    {
      image: img4,
      title: "Manage seasonal needs",
      text: "In the competitive landscape of seasonal hiring, DailyPay gives you an edge. Minimize the financial burden of turnover — with costs averaging $10,000 per frontline retail employee.5",
    },
    {
      image: img5,
      title: "Increased engagement & reduced employee absenteeism",
      text: "Offer your employees the flexibility and control they need to manage their finances, leading to increased engagement and reduced absenteeism.",
    },
    {
      image: img6,
      title: "Improved financial wellness",
      text: "70% of DailyPay users in the retail industry say that DailyPay helps them feel more confident in managing their finances.6",
    },
    {
      image: img7,
      title: "Competitive benefit",
       text:"DailyPay gives retail employers a competitive edge by offering instant access to earned pay. This attracts talent by demonstrating a commitment to employee wellness.",   
 },
    // {
    //   image: img8,
    //   title: "Improved productivity",
    //   text: "42% of DailyPay users in healthcare, medical, or social assistance industries say they are more productive at work because they have DailyPay.8",
    // },
  ];

  const visibleCards = 4;

  const [currentIndex, setCurrentIndex] = useState(0);

  // CARD WIDTH + GAP
  const slideAmount = 324;

  // NEXT
  const handleNext = () => {
    if (currentIndex < cards.length - visibleCards) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // PREV
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <section className="w-full bg-white lg:mt-[50px] overflow-hidden">

      <div className="max-w-7xl mx-auto relative px-2">

        {/* LEFT BUTTON */}
        {currentIndex > 0 && (
          <button
            onClick={handlePrev}
            className="
              absolute
              left-[-25px]
              top-[38%]
              -translate-y-1/2
              z-20
              w-14
              h-14
              rounded-full
              bg-white
              hover:bg-[#4b0000]
                hover:text-white
              border
              shadow-md
              flex
              items-center
              justify-center
            "
          >
            <ChevronLeft size={34} />
          </button>
        )}

        {/* RIGHT BUTTON */}
        {currentIndex < cards.length - visibleCards && (
          <button
            onClick={handleNext}
            className="
              absolute
              right-[-25px]
              top-[38%]
              -translate-y-1/2
              z-20
              w-14
              h-14
              rounded-full
              bg-white
                hover:bg-[#4b0000]
                hover:text-white
              border
              shadow-md
              flex
              items-center
              justify-center
            "
          >
            <ChevronRight size={34} />
          </button>
        )}

        {/* SLIDER */}
        <div className="overflow-hidden">

          <div
            className="flex gap-6 transition-all duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * slideAmount}px)`,
            }}
          >

            {cards.map((card, index) => (
              <div
                key={index}
                className="
                  w-[300px]
                  min-w-[300px]
                  lg:h-[400px]
                  bg-[#f5f5f5]
                  rounded-[30px]
                  p-8
                  h-[520px]
                  flex-shrink-0
                "
              >

                {/* IMAGE */}
                <img
                  src={card.image}
                  alt=""
                  className="w-24 h-26 object-contain mb-8"
                />

                {/* TITLE */}
               <h2 className="text-[18px] lg:text-[20px] font-extrabold leading-tight text-black font-serif -mt-2">
  {card.title}
</h2>

                {/* TEXT */}
                <p className="mt-8 lg:mt-6 text-[16px] lg:text-[16px] leading-[1.5] lg:leading-[1.3] text-[#280303] font-[500]">
                  {card.text}
                </p>

              </div>
            ))}

          </div>

        </div>

        {/* DOTS */}
        <div className="flex justify-center items-center gap-3 mt-10">

          <div
            className={`
              w-3
              h-3
              rounded-full
              ${currentIndex <= 1 ? "bg-black" : "bg-gray-300"}
            `}
          />

          <div
            className={`
              w-3
              h-3
              rounded-full
              ${currentIndex >= 2 ? "bg-black" : "bg-gray-300"}
            `}
          />

        </div>

      </div>
      {/* FOOTNOTES */}
<div className="max-w-[1400px] mx-auto px-4 mt-8 mb-20 lg:ml-[110px]">

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup> 1 </sup> Retail Workers Research commissioned by Talker, June 2025
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>2, 3, 6</sup> DailyPay Employer Experience Research, Arizent study commissioned by DailyPay, September 2023
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>4</sup>Puma Improves Timecard Reconciliation and Boosts Employee Engagement With DailyPay
  </p>

  <p className="text-[12px] text-[#5a5f73] leading-6">
    <sup>5</sup>McKinsey & Company, “How Retailers Can Build and Retain a Strong Frontline Workforce in 2024”, July 17, 2024
  </p>

</div>

    </section>
  );
}